import { Component, Input } from '@angular/core';
import { Direction } from '@angular/cdk/bidi';
import { filter } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { L10nService } from '@nano/core/l10n';

@UntilDestroy()
@Component({
  selector: 'app-icon-with-popover',
  templateUrl: './icon-with-popover.component.html',
  styleUrls: ['./icon-with-popover.component.less'],
  standalone: false
})
export class IconWithPopoverComponent {
  @Input() icon = 'alert-circle';
  @Input() iconInlineSvg: true | false = true;

  @Input() popoverContent: string;
  @Input() popoverContentParams: unknown;

  @Input() popoverPlacement?:
    | 'top'
    | 'left'
    | 'right'
    | 'bottom'
    | 'topLeft'
    | 'topRight'
    | 'bottomLeft'
    | 'bottomRight'
    | 'leftTop'
    | 'leftBottom'
    | 'rightTop'
    | 'rightBottom'
    | Array<string> = 'top';

  direction: Direction;

  constructor(private l10nService: L10nService) {
    this.l10nService.schema$
      .pipe(
        untilDestroyed(this),
        filter((schema) => !!schema)
      )
      .subscribe((schema) => (this.direction = schema.dir));
  }
}
